import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Toolbar } from '@material-ui/core';

import Menu from 'components/Menu';
import TopBar from 'components/TopBar';
import ModalNotifications from 'components/Modals/ModalNotifications';
// import Rewards from './Rewards';
import History from './History';
import MenuManagment from './MenuManagment';
import Support from './Support';
import Settings from './Settings';
import PaymentIssues from './PaymentIssues';
import Insights from './Insights';
import Reporting from './Reporting';
import Quality from './Quality';
import Orders from './Orders';

import {
  Box,
  Container,
  Content,
  ChatButton,
  ChatBubbleIcon,
  Loader,
  NavLink,
} from './styles';

import useConnect from './connect';

const Main = () => {
  const {
    openReferal,
    handleOpenReferal,
    handleCloseReferal,
    openMenu,
    handleCloseMenu,
    handleOpenMenu,
    isTablet,
    logout,
    me,
    isLoading,
    modalNotifications,
    closeModalNotification,
  } = useConnect();

  if (isLoading || !me) return <Loader />;
  return (
    <Container>
      {isTablet ? (
        <Menu
          openMenu={openMenu}
          handleCloseMenu={handleCloseMenu}
          handleLogout={logout}
          canAccessInsights={me.canAccessInsights}
          openReferal={openReferal}
          handleOpenReferal={handleOpenReferal}
          handleCloseReferal={handleCloseReferal}
          hasOrdering={me.hasOrdering}
        />
      ) : (
        <Menu
          handleLogout={logout}
          canAccessInsights={me.canAccessInsights}
          openReferal={openReferal}
          handleOpenReferal={handleOpenReferal}
          handleCloseReferal={handleCloseReferal}
          hasOrdering={me.hasOrdering}
        />
      )}

      <Content>
        {me.paymentIssues.length !== 0 && (
          <Box>
            <Toolbar>
              Due to issues from the delivery platforms, your location may have
              slight delays in payments. Click
              <NavLink to="/payment-issues">here</NavLink>
              to read more.
            </Toolbar>
          </Box>
        )}
        <TopBar handleOpenMenu={handleOpenMenu} isTablet={isTablet} />
        <ModalNotifications
          modalNotifications={modalNotifications}
          handleClose={closeModalNotification}
        />
        <Switch>
          {/* <Route component={Rewards} path="/rewards" /> */}
          <Route component={History} path="/history" />
          <Route component={Quality} path="/quality" />
          <Route component={Support} path="/support" />
          <Route component={Settings} path="/settings" />
          {me.hasOrdering && <Route component={Orders} path="/orders" />}
          {me.hasOrdering && <Route component={Reporting} path="/reporting" />}
          {me.hasOrdering && (
            <Route component={MenuManagment} path="/menu-manager" />
          )}
          {me.canAccessInsights && (
            <Route component={Insights} path="/insights" />
          )}
          {me.paymentIssues.length !== 0 && (
            <Route component={PaymentIssues} path="/payment-issues" />
          )}

          <Redirect to={me.hasOrdering ? '/orders' : '/insights'} />
        </Switch>
      </Content>
      <ChatButton id="chatbot_cookdash">
        <ChatBubbleIcon />
      </ChatButton>
    </Container>
  );
};

export default Main;
